// Daftar domain RBAC yang dikenal aplikasi ini. Menambah domain baru (mis.
// SMS - Stakeholder Management System) cukup dengan menambah entri di sini
// SETELAH katalog permission & role sistemnya di-seed lewat migration di
// sa-back-end (lihat migration_rbac_domains.sql) -- tidak ada kode lain yang
// perlu diubah, RoleList/RoleForm/EmployeeAccess semuanya membaca dari sini.
const DOMAINS = [
  { code: 'CLP', label: 'Campus Leaders Program', icon: 'bi-mortarboard-fill' },
  { code: 'HOL', label: 'Home of Leaders', icon: 'bi-award-fill' },
  { code: 'SMS', label: 'Stakeholder Management System', icon: 'bi-diagram-3-fill' },
];

export default DOMAINS;
